import { Alert, Button } from "@mui/material";
import { toast } from "react-hot-toast";

import type { FC } from "react";

export const UploadFileFailedToast: FC<{ filename: string; onClick: () => void }> = ({
  filename,
  onClick,
}) => (
  <Alert
    severity="error"
    action={
      <Button
        onClick={() => {
          toast.remove();
          onClick();
        }}
        data-analytics-id="upload-file-error-toast-try-again"
        variant="text"
      >
        Try again
      </Button>
    }
    sx={{ alignItems: "center", "& .MuiAlert-action": { pt: 0 } }}
  >
    {`There was a problem uploading '${filename}'`}
  </Alert>
);
